<!-- 个人信息 -->
<template>
    <div class="" >
    <!-- <PageBack :title="title" /> -->
    <!-- <Breadcrumb :title="title" /> -->
    <div class="detail-wrap">
        <el-tabs v-model="activeName" @tab-click="changeTabs"  type="border-card" style="min-height: 600px;">
        <el-tab-pane label="个人信息修改" name="first" >                         
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="username">
                            <el-input v-model="ruleForm.username" placeholder="姓名" maxlength="10"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="ruleForm.phone" 
                                @input="handlePhone"    placeholder="手机号" maxlength="11"/>
                        </el-form-item>
                    </el-col>
                </el-row>                
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="角色" prop="role" >
                            <el-select v-model="ruleForm.role" style="width:100%" :disabled="true">
                                <el-option 
                                    v-for="item in roleOption"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                            </el-select>                    
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="等级" >
                            <el-input style="color:red" v-model="ruleForm.level" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>  
                <!-- <el-form-item label="等级" prop="level"  >
                    <el-select v-model="ruleForm.level" style="width:100%" :disabled="true">
                        <el-option 
                            v-for="item in levelOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司名" prop="company">
                    <el-input v-model="ruleForm.company" placeholder="公司名"></el-input>
                </el-form-item> -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="身份证正面" prop="imageUrl1" class="form" >
                            <el-upload class="avatar-uploader" ref="coverPicUpload1" action="" list-type="picture-card" accept="image/*"
                                multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest1" 
                                :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                                <el-image v-if="!ruleForm.imageUrl1" :src="ruleForm.imageUrl1">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-plus" />
                                </div>
                                </el-image>
                                <div v-else class="image">
                                <el-image :src="ruleForm.imageUrl1" :style="`width:150px;height:150px;`" fit="fill" />
                                <div class="mask">
                                    <div class="actions">
                                    <span title="移除" @click.stop="handleRemove1">
                                        <i class="el-icon-delete" />
                                    </span>
                                    </div>
                                </div>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证反面" prop="imageUrl2" class="form" >
                            <el-upload class="avatar-uploader" ref="coverPicUpload2" action="" list-type="picture-card" accept="image/*"
                                multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest2"
                                :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                                <el-image v-if="!ruleForm.imageUrl2" :src="ruleForm.imageUrl2">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-plus" />
                                </div>
                                </el-image>
                                <div v-else class="image">
                                <el-image :src="ruleForm.imageUrl2" :style="`width:150px;height:150px;`" fit="fill" />
                                <div class="mask">
                                    <div class="actions">
                                    <span title="移除" @click.stop="handleRemove2">
                                        <i class="el-icon-delete" />
                                    </span>
                                    </div>
                                </div>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="上传凭证" prop="imageUrl3" class="form" >
                    <el-upload class="avatar-uploader" ref="coverPicUpload3" action="" list-type="picture-card" accept="image/*"
                        multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest3"
                        :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                        <el-image v-if="!ruleForm.imageUrl3" :src="ruleForm.imageUrl3">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-plus" />
                        </div>
                        </el-image>
                        <div v-else class="image">
                        <el-image :src="ruleForm.imageUrl3" :style="`width:150px;height:150px;`" fit="fill" />
                        <div class="mask">
                            <div class="actions">
                            <span title="移除" @click.stop="handleRemove3">
                                <i class="el-icon-delete" />
                            </span>
                            </div>
                        </div>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="false" style="width: 220px;"
                        @click="submit('ruleForm')" >提交</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="入会申请" name="second">
            <!-- <el-form :model="ruleForm2" :rules="rules" ref="ruleForm2" label-width="100px">
                <el-form-item label="入会理由" prop="reason">
                    <el-input type="textarea" :rows="4" v-model="ruleForm2.reason" placeholder="入会理由"/>
                </el-form-item>
                <el-form-item label="选择协会" prop="clubName">
                    <el-select v-model="ruleForm2.clubName" style="width:100%">
                        <el-option 
                            v-for="item in clubOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="协会角色" prop="clubRole" >
                    <el-select v-model="ruleForm2.clubRole" style="width:100%">
                        <el-option 
                            v-for="item in clubRoleOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="false" style="width: 220px;"
                        @click="clubSubmit('ruleForm2')">提交</el-button>
                </el-form-item>
            </el-form>   -->
            <join-club></join-club>
        </el-tab-pane>
        <el-tab-pane label="我加入的协会(俱乐部)" name="third">
            <el-table border :data="tableData" style="margin-top:30px;">
                <el-table-column  prop="clubId"   label="协会(俱乐部)账号"   width="100" />
                <el-table-column  prop="clubName"  label="协会(俱乐部)简称"  width="120"/>
                <el-table-column  prop="clubPosition"    label="协会职务"/>
                <el-table-column  prop="role"    label="协会角色"/>
                <el-table-column  prop="grade"  label="协会积分"/>
                <el-table-column  prop="level"  label="协会等级"/>
                <el-table-column  prop="date"  label="加入日期"/>
                <el-table-column  prop="status"  label="状态"/>
                <!-- <el-table-column  fixed="right" label="操作"  width="120">
                    <template slot-scope="scope">
                        <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>   
                        <el-button v-if="scope.row.status === '入会申请' || scope.row.status === '退会申请'" 
                        @click="auditDialog(scope.row)" type="text" size="medium">审核</el-button>
                    </template>                                   
                </el-table-column> -->
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="fourth">
            <update-password> </update-password>
        </el-tab-pane>
    </el-tabs>
</div></div>
</template>
  
<script>
import Breadcrumb from '@/components/Breadcrumb'
import PageBack from '@/components/PageHeader'
import JoinClub from './components/joinClub'
import UpdatePassword from './components/updatePassword'
export default {
components: {
    Breadcrumb,
    PageBack,
    JoinClub,
    UpdatePassword
},
data() {
    return {
        activeName: 'first',
        loading: false,
        ruleForm: {
            username: '',
            phone: '',
            role:'',
            level: '',
            company:'',  
            imageUrl1: '',
            imageUrl2: '',  
            imageUrl3: '',          
        },
        ruleForm2: {
            clubRole: '',
            reason: '',
            clubName: '',
        },
        rules: {
            username: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
                { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
            ],
            role: [
                { required: false, message: '请选择角色', trigger: 'change' },
            ],
            level: [
                { required: false, message: '请选择等级', trigger: 'change' },
            ],  
            imageUrl1: [
                { required: true, message: '请上传身份证正面', trigger: 'change' }
            ],
            imageUrl2: [
                { required: true, message: '请上传身份证反面', trigger: 'change' }
            ],
            reason: [
                { required: true, message: '请输入入会理由', trigger: 'blur' },
            ],
            clubRole: [
                { required: true, message: '请选择协会角色', trigger: 'change' }
            ],
            clubName: [
                { required: true, message: '请选择协会', trigger: 'change' }
            ]
        },
        pwType: 'text',
        pwKey: 0,
        roleOption: [],
        levelOption: [],
        clubOption: [],
        clubRoleOption: [],
        imageRole: '',
        imageLevel: '',
        imageLisence: '',
        tableData: []
    }
},
created() {
    this.getUserRole()
    this.getClubRole()
        
    setTimeout(()=>{
        this.accountInfo()
    },100)          
},
mounted() {
    
},
computed: {
    title() {
        return this.$route.meta.title
    },
},
methods: {
    accountInfo() {
        let params = {
            opcode: this.$code.UserInfo
        }
        // 查询账户信息
        this.$api.requestAPI(params).then(res => {
            if (res.IsSuccess) {                    
                let result = res.Data.DataTable;
                if(result.length > 0){
                    let list = result.map(item=>{
                    let role = this.roleOption.filter(i=>i.label == item['角色'])
                        return{
                            username: item['姓名'],
                            phone: item['手机号'],
                            role: role[0].value,
                            level: item['等级'],
                            company: item['公司'],
                            imageUrl1: item['凭证正面'],
                            imageUrl2: item['凭证背面'],  
                            imagesUrl3: item['备注']  
                        }
                    })  
                    this.ruleForm = list[0]    
                    this.ruleForm.imageUrl1 = list[0].imageUrl1
                    this.ruleForm.imageUrl2 = list[0].imageUrl2
                    this.ruleForm.imageUrl3 = list[0].imageUrl3
                    // this.imageRole  = list[0].imageUrl1
                    // this.imageLevel = list[0].imageUrl2
                    // this.imageLisence = list[0].imageUrl3
                }  
            }else{
            }
        }).catch(err => {
            console.log('error submit!!');
        })
    },
    // 获取用户角色
    getUserRole(){
        let params = {
            opcode: this.$code.SystemCode,
            v_parent_name: '',
            i_no: 10,
        }
        this.$api._requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                this.roleOption = result.map(item=>{
                    return{
                        value: item['词条索引'],
                        label: item['中文描述']
                    }
                })
            }
        })
    },
        // 获取用户等级
        getUserLevel(){
        let params = {
            opcode: this.$code.SystemCode,
            v_parent_name: '',
            i_no: 19,
        }
        this.$api._requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                this.levelOption = result.map(item=>{
                    return{
                        value: item['词条索引'],
                        label: item['中文描述']
                    }
                })
            }
        })
    },
    // 查询所有协会
    getUserAssocication(){
        let params = {
            opcode: this.$code.UserAssociation,
            i_client_no:  0
        }
        this.$api._requestAPI(params).then(res => {
            if (res.IsSuccess) {   
                let result = res.Data.DataTable
                this.clubOption = result.map(item =>{
                    return{
                        value: item['协会(俱乐部)账号'],
                        label: item['协会(俱乐部)全称'],
                    }
                })
            }
        })
    },
    // 获取协会角色
    getClubRole(){
        let params = {
            opcode: this.$code.SystemCode,
            v_parent_name: '',
            i_no: 11,
        }
        this.$api._requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                this.clubRoleOption = result.map(item=>{
                    return{
                        value: item['词条索引'],
                        label: item['中文描述']
                    }
                })
            }
        })
    },
    clubSubmit(formName){
        let { reason, clubName, clubRole} = this.ruleForm2
        this.$refs[formName].validate((valid) => {
            if(valid){
                let params = {
                    opcode: this.$code.ApplyClub,
                    i_client_no: clubName,
                    v_reason: reason,
                    i_type: clubRole
                }
                this.$api.requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        this.$message.success(res.Message)
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }else {
                console.log('error submit!!');
                return false;
            }
        })
    },
    submit(formName) {
        let { username, role, phone, level, company, imageUrl1,imageUrl2,imageUrl3} = this.ruleForm;
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let params = {
                    opcode: this.$code.UserInfoUpdate,
                    v_name: username,
                    v_caption: username,
                    v_phone: phone,
                    v_company: company,
                    // c_type: role,
                    // i_starrating: level,
                    i_voucher_up_image: imageUrl1,
                    i_voucher_down_image: imageUrl2 ,
                    //非必填字段 
                    i_avatar_image: '',
                    v_synopsis: '',   
                    v_details: '',
                    v_summary: imageUrl3,                     
                }
                this.$api.requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        setTimeout(() => {                                
                            this.$message.success(res.Message)
                        }, 100);
                    } else {
                        this.$message.error(res.Message)
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            } else {
                console.log('error submit!!');
                return false;
            }
        })
    },
    pwInput(e) {
        if (e) {
            this.pwType = 'password'
        } else {
            this.pwKey++
            this.pwType = 'text'
        }
    },
    async handleRequest1(file,fileList){
        let url = await this.$help.uploadRequest(file)
        // this.imageRole  = url
        this.ruleForm.imageUrl1 = this.$global.uploadUrl + url
        this.loading.close();
        this.$refs.coverPicUpload1.clearFiles()
    },
    async handleRequest2(file,fileList){
        let url = await this.$help.uploadRequest(file)
        // this.imageLevel  = url
        this.ruleForm.imageUrl2 = this.$global.uploadUrl + url
        this.loading.close();
        this.$refs.coverPicUpload2.clearFiles()
    },
    async handleRequest3(file,fileList){
        let url = await this.$help.uploadRequest(file)
        // this.imageLisence  = url
        this.ruleForm.imageUrl3 = this.$global.uploadUrl + url
        this.loading.close();
        this.$refs.coverPicUpload3.clearFiles()
    },
    handleRemove1(file, fileList) {
        // this.imageRole = ''
        this.ruleForm.imageUrl1 = ''
    },
    handleRemove2(file, fileList) {
        // this.imageLevel = ''
        this.ruleForm.imageUrl2 = ''
    },
    handleRemove3(file, fileList) {
        // this.imageLisence = ''
        this.ruleForm.imageUrl3 = ''
    },
    handleBeforeUpload() {
        this.loading = this.$loading({
            lock: true,
            text: "上传中",
            background: "rgba(0, 0, 0, 0.7)",
        });
        this.loading.close();
    },
    handleUploadError() {
        this.$message({
            type: "error",
            message: "上传失败",
        });
        this.loading.close();
    },
    // 查询会员所在协会
    getMemberAssocication(){
        let params = {
            opcode: this.$code.MemberAssociation,
            c_status: ''
        }
        this.$api.requestAPI(params).then(res => {
            if (res.IsSuccess) {   
                let result = res.Data.DataTable
                if(result.length > 0){                        
                    this.tableData = result.map(item=>{
                    let role = this.clubRoleOption.filter(i=>i.value == item['协会角色'])
                    return{
                        clubId: item['协会(俱乐部)账号'],
                        clubName: item['协会(俱乐部)简称'],
                        clubPosition: item['协会职务'], 
                        grade: item['协会积分'],
                        level:item['协会等级'],                          
                        role: role[0].label,
                        status: item['状态'],
                        date:  this.$help.formatDate(item['准入日期']) 
                    }
                    })
                }                    
            }
        })
    }, 
    changeTabs(){
        if(this.activeName === 'third'){
            this.getMemberAssocication()
        }else if(this.activeName === 'second'){
            this.getUserAssocication()
        }
    },
    handlePhone(value){
        const pattern = /^[0-9]\d*$/g
        if (pattern.test(value)) {
            // 双向绑定
            this.ruleForm.phone = value
        } else {
            // 输入值不为正整数，则从中提取出数字并拼接为字符串
            const num = value.match(/\d+/g)
            this.ruleForm.phone = num ? num.join('') : ''
        }
    }
},       
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap {
    width: 1000px;
}

.title {
    padding: 30px;
    font-size: 22px;
}

.image {
    position: relative;

.mask {
    opacity: 0;
    position: absolute; 
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
}

&:hover .mask {
    opacity: 1;
}
}
</style>


// WEBPACK FOOTER //
// src/views/userInfo/userInfo.vue